import { useContext } from 'react'
import {
  type SeenApi,
  SeenApiContext,
} from '#src/contexts/seen-api/SeenApiContext.tsx'

export const useSeenApi = (): SeenApi => {
  const context = useContext(SeenApiContext)
  if (context === null) {
    throw new Error('useSeenApi must be used within SeenApiContextProvider')
  }
  return context
}
